import React from 'react';
import { EmptyStatesIllustration } from 'cdk-radial';
import '../MyAPIs/Tabs/APIs/APIs.css';

export const NoDataOverlay = ({message}) => {
    return (
      <div className='empty-state-illustration' data-testid="no-apis-overlay">
        <EmptyStatesIllustration size={200}/>
        <p className='no_apis_text'>{message}</p>
      </div>

    );
  };